import type { ReactNode } from 'react';

interface GlassCardProps {
    children: ReactNode;
    className?: string;
    onClick?: () => void;
}

export default function GlassCard({ children, className = '', onClick }: GlassCardProps) {
    return (
        <div
            onClick={onClick}
            className={`glass-card rounded-2xl p-6 transition-all duration-300 ${onClick ? 'cursor-pointer hover:bg-white/[0.08]' : ''} ${className}`}
        >
            {children}
        </div>
    );
}
